import { CloseOutlined } from "@ant-design/icons";
import { Tabs, Tooltip } from "antd";
import StockDocMain from "./stock-doc-main";
import StockDocCnts from "./stock-doc-cnts";
import { useState, useEffect } from "react";
import StockDocMoves from "./stock-doc-moves";
import { isMobile } from "@/extensions/design";

const StockDoc = ({ id, onClose, onDocDataChanged }) => {
  const [vid, setVid] = useState();
  const [scanFn, setScanFn] = useState(null); //Сканирование на мобильном вынесено наверх
  const [closeScanFn, setCloseScanFn] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [docMainRefreshKey, setDocMainRefreshKey] = useState(0);

  const onCntSaved = () => {
    setDocMainRefreshKey((k) => k + 1);
    onDocDataChanged?.();
  };

  const items = [
    { children: <StockDocMain id={id} onClose={onClose} setVid={setVid} refreshKey={docMainRefreshKey} />, label: "Шапка", key: "1" },
  ]

  if (id) {
    items.push({children: <StockDocCnts id={id} onClose={onClose} vid={vid} onCntSaved={onCntSaved} exposeScan={ isMobile ? setScanFn : null } exposeCloseScan={ isMobile ? setCloseScanFn : null }/>, label: "Содержимое", key: "2"});
    items.push({children: <StockDocMoves id={id} />, label: "Движения", key: "3"});
  }

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()} style={ !isMobile ? {width: 900} : {} }>
        <div className={(isMobile) ? "sport-modal-title" : "client-modal-title" }>
          <span>Накладная</span>
          { isMobile && activeTab === "2" && typeof scanFn === "function" && 
            <div style={{display: "flex", width: "60%", justifyContent: "flex-end"}}>
              <Tooltip title="Просканируйте штрихкод товара"><img src="/images/scan.svg" style={{width: 32}} alt="scan" onClick={() => scanFn()}/></Tooltip>
            </div>
          }
          <CloseOutlined
            className="sport-section-title-close" 
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <div className={ !isMobile ? "custom-tabs-container" : ""}>
          <Tabs type={ !isMobile ? "card" : "line"} activeKey={activeTab} onChange={setActiveTab} items={items} defaultActiveKey={1}
             className={!isMobile ? "custom-tabs" : "no-custom-tabs no-custom-tabs-mobile no-custom-tabs-mobile-client-abons-tabs"} />
        </div>
      </div>
    </div>
  </div>
}

export default StockDoc;